import { useQuery } from "@tanstack/react-query";
import { useGetVendorId } from "../global/User";
import api from '../../services/api';

export const useGetCountAndAverageScore = (group='', product='', createdAfterDate='', createdBeforeDate='') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/countandaveragescore?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`)
        return data;
    };
    return useQuery({ queryKey: ['CountAndAverageScore'], queryFn: fetchData, enabled: false });
};
export const useGetCompereCountAndAverageScore = (group='', product='', createdAfterDate='', createdBeforeDate='') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/countandaveragescore?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`)
        return data;
    };
    return useQuery({ queryKey: ['useGetCompereCountAndAverageScore'], queryFn: fetchData, enabled: false });
};

export const useScoreStatistics = (group='', product='', createdAfterDate='', createdBeforeDate='') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/scorestatistics?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`);      return data;
    };
    return useQuery({ queryKey: ['ScoreStatistics'], queryFn: fetchData, enabled: false });
};

export const useGetNpsScore = (group='', product='', createdAfterDate='', createdBeforeDate='', label= '') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/npsscore?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`);      
        return data;
    };
    return useQuery({ queryKey: ['GetNpsScore', label], queryFn: fetchData, enabled: false });
};

export const useGetDetailedRatings = (group='', product='', createdAfterDate='', createdBeforeDate='', label= '') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/detailedratings?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`);      
        return data;
    };
    return useQuery({ queryKey: ['useGetDetailedRatings', label], queryFn: fetchData, enabled: false });
};

export const useGetHighestRatings = (group='', product='', createdAfterDate='', createdBeforeDate='', label= '') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/highestratings?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`);      
        return data;
    };
    return useQuery({ queryKey: ['HighestRatings', label], queryFn: fetchData, enabled: false });
};

export const useGetForTable = (group='', product='', createdAfterDate='', createdBeforeDate='', label= '') => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get( `feedback/forTable?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}&lng=SL`);      
        return data;
    };
    return useQuery({ queryKey: ['ForTable', label], queryFn: fetchData, enabled: false });
};



